import { Method } from './utils/api-client-utils';
import ApiClientV2 from './utils/api-client-v2';

export const apiClient = new ApiClientV2({ microservice: 'billing' });
export const pdfClient = new ApiClientV2({ microservice: 'pdf' });
export const coreApiClient = new ApiClientV2({ microservice: 'core' });
export const headerJSON = { 'Content-Type': 'application/json' };

export const getProgressionOfCareHeader = (
  patientId,
  body = {},
  optOutLoadingIndicator = false,
) =>
  apiClient.makeRequest({
    method: Method.POST,
    path: '/api/v1/tenants/:tenantId/patients/:patientId/progression-of-care-header',
    replacements: { patientId },
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
    optOutLoadingIndicator,
  });

export async function printProgressionOfCareSummary({
  updatedPdfBody,
  optOutLoadingIndicator,
}) {
  const res = await pdfClient.makeRequest({
    method: Method.POST,
    path: '/api/v5/tenants/:tenantId/progression-of-care',
    optOutLoadingIndicator,
    body: JSON.stringify(updatedPdfBody),
  });

  return res.buffer;
}

export const getProgressionOfCare = async (patientId, signal) => {
  const response = await coreApiClient.makeRequest({
    path: '/api/v1/tenants/:tenantId/progression-of-care/patients/:patientId',
    replacements: { patientId },
    method: Method.GET,
    headers: headerJSON,
    version: 1,
    optOutLoadingIndicator: true,
    ...(signal ? { signal } : {}),
  });

  return response.data;
};

export const generateProgressionOfCare = async (
  patientId,
  signal,
  filters = {},
) => {
  const {
    providerIds = [],
    caseIds = [],
    dosFrom = null,
    dosTo = null,
  } = filters;

  const requestBody = {
    providerIds,
    caseIds,
    dosFrom,
    dosTo,
  };

  const response = await coreApiClient.makeRequest({
    path: '/api/v1/tenants/:tenantId/progression-of-care/patients/:patientId',
    replacements: { patientId },
    method: Method.POST,
    headers: headerJSON,
    body: JSON.stringify(requestBody),
    version: 1,
    optOutLoadingIndicator: true,
    ...(signal ? { signal } : {}),
  });

  return response.data;
};
